import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BrowseListItem from './BrowseListItem';
import BrowseListSkeleton from '../skeleton/BrowseListSkeleton';
import genPlaceHolderProducts from '../../utils/genPlaceHolderProducts';
import {Product} from '../../../../../shared/types';
import {useGetMessages} from '../../../../hooks';
import {useSelector} from 'react-redux';
import {selectAccountId, selectStoreBaseUrl} from '../../../../selectors';

const CODES = {
    shareRate: 'epic.affiliate.earnings.sort_share_rate',
    fnShareRate: 'epic.affiliate.earnings.my_earnings.fortnite_share_rate',
    copyLink: 'epic.affiliate.earnings.card.copy_link',
    copyLinkSuccess: 'epic.affiliate.earnings.card.copy_link.success',
    copyLinkFail: 'epic.affiliate.earnings.card.copy_link.failed',
    copyLinkDisabled: 'epic.affiliate.earnings.card.copy_link.disabled.v2',
    noResultsFound: 'epic.affiliate.common.search.noResults.title',
    noResultsFoundSearch: 'epic.affiliate.common.search.noResults.details'
};

export interface BrowseListProps {
    products: Product[];
    enableLink?: boolean;
    isRendering?: boolean;
    postsPerPage?: number;
}

export type BrowseListMessages = typeof CODES;

const placeholderProducts = genPlaceHolderProducts(18);

const BrowseList: React.FC<BrowseListProps> = ({
    products,
    enableLink,
    isRendering = false,
    postsPerPage
}) => {
    const accountId = useSelector(selectAccountId);
    const baseStoreUrl = useSelector(selectStoreBaseUrl);
    const messages = useGetMessages(CODES);

    if (isRendering) {
        return (
            <BrowseListSkeleton
                products={
                    postsPerPage > 18 ? genPlaceHolderProducts(postsPerPage) : placeholderProducts
                }
            />
        );
    }

    return (
        <Grid container spacing={2}>
            {!products.length ? (
                <Grid item xs={12}>
                    <Box display="flex" flexDirection="column" alignItems="center" margin={50}>
                        <Typography variant="h1">{messages.noResultsFound}</Typography>
                        <Typography color="textSecondary">
                            {messages.noResultsFoundSearch}
                        </Typography>
                    </Box>
                </Grid>
            ) : (
                products.map((game, i) => (
                    <Grid key={`game-${i}`} item xl={2} md={3} xs={6}>
                        <BrowseListItem
                            key={game.namespace}
                            item={game}
                            enableLink={enableLink}
                            accountId={accountId}
                            baseStoreUrl={baseStoreUrl}
                            messages={messages}
                        />
                    </Grid>
                ))
            )}
        </Grid>
    );
};

export default BrowseList;
